module.exports = __webpack_public_path__ + "static/img/14010012.c06a65a0.png";